import { render, staticRenderFns } from "./TimeLogSummaryShimmer.vue?vue&type=template&id=0372a6e2&"
import script from "./TimeLogSummaryShimmer.vue?vue&type=script&lang=js&"
export * from "./TimeLogSummaryShimmer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports